module.exports = __webpack_public_path__ + "static/product-c7832ec6cb81bef4559a4d1919fac0d8.jpg";